<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LwQoTQ/tc-custom/9781398499201.jpg?1705540687310" alt="This image is the cover for the book East"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">East
      </h1>
      <p class="bookDescription body article font2">
        <p>In East, society has abolished money, property ownership, names, gender, marriage, and religion, and is controlled by a ruling class. A392 must navigate this dystopian world, full of propaganda and a poor citizen score, while questioning the belief in this system that has been instilled since birth. Along the way, A392 encounters the Silencers, suspicious citizens, and a mysterious owl, ultimately leading to a journey that delves into the importance of individual freedom and the right to think and live freely without government interference.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Garrett
      </h2>
      
      <p class="authorDescription body article">Jonathan Garrett is a high school teacher who lives in Brisbane, Australia, with his wife and five children. He has a Bachelor of Education, majoring in modern history, and has studied political history and the ramifications of totalitarianism. He currently teaches English, history and business at a local independent school.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?25f9b773